export default __webpack_public_path__ + "static/media/map-validator.72100237.svg";